<template>
  <div class="rigth_Infwarp">
    <el-card style="height:100%">
      <p>各地区户口性质占比</p>
      <div class="infro" ref="MyEcharts"></div>
    </el-card>
  </div>
</template>

<script>
import { classInfoData } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.infoDataFren();
  },
  methods: {
    async infoDataFren() {
      const { code, data, msg } = await classInfoData();
      if (code === 200) {
        let xActive = [];
        let jiArr = []; //集体户
        let jiaARR = []; //家庭户
        for (const item of data) {
          xActive.push(item.house);
          jiArr.push(item.cnt2);
          jiaARR.push(item.cnt);
        }
        this.getInfo(xActive, jiArr, jiaARR);
      }
    },
    getInfo(xActive, jiArr, jiaARR) {
      let myehcarts = this.$echarts.init(this.$refs.MyEcharts);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["集体户", "家庭户"],
        },
        grid: {
          bottom: "5%",
          left:"4%",
          right:"4%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          // orient: "vertical",
          left: "right",
          // top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: xActive,
            axisLabel: { rotate: -50, interval: 0 }
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "集体户",
            type: "bar",
            // barGap: 0,
            emphasis: {
              focus: "series",
            },
            data: jiArr,
            itemStyle: {
              normal: {
                color: "#FF0000",
              },
            },
          },
          {
            name: "家庭户",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            data: jiaARR,
            itemStyle: {
              normal: {
                color: "#FF7800",
              },
            },
          },
        ],
      };
      myehcarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.rigth_Infwarp {
  height: 500px;
  margin: 10px 0;
  .el-card__body {
    height: 100%;
    .infro {
      height: 90%;
    }
  }
}
</style>
